import useGetTreatment from 'hooks/treatments/useGetTreatment'
import { TreatmentFlags, treatmentFlagValues } from 'constants/treatments'
import { isPatientUser } from 'utils/common'

export function usePrimaryBookButtonProfileV2(): { isEnabled: boolean } {
  const treatment = useGetTreatment(
    TreatmentFlags.PRIMARY_BOOK_BUTTON_PROFILE_V2,
    isPatientUser()
  )

  return { isEnabled: treatment === treatmentFlagValues.ON }
}

export default usePrimaryBookButtonProfileV2
